// if coming from another page
// store the hash (DON'T put this code inside the $() function, it has to be executed
// right away before the browser can start scrolling!
var hash = window.location.hash;
if( hash ) {

	// delete hash so the page won't scroll to it
	window.location.hash = "";
	// if coming from another page

}





(function ($, root, undefined) {

	$(function () {

		'use strict';

		// DOM ready, take it away




        if( sessionStorage ){

        	if( !sessionStorage.getItem('isshow') ) {

	            $('#covid_banner').show();
	            sessionStorage.setItem('isshow', 'true');

        	} else if( sessionStorage.getItem('isshow') === 'true' ) {

	            $('#covid_banner').show();
	            sessionStorage.setItem('isshow', 'true' );

        	}

        }

		$("span.closebtn").click(function() {
			$('#covid_banner').hide();
			sessionStorage.setItem('isshow', 'false');
		});




		// Smooth Scroll
		//
		var top_space = 0;

		if( width <= 1023 ) {
			top_space = 0;
		} else {
			top_space = 80;
		}

		function scroll_to( hash, myTimeout ) {

			setTimeout(function(){

				// https://stackoverflow.com/questions/6677035/jquery-scroll-to-element
				$('html, body').animate({
					scrollTop: $(hash).offset().top-top_space
				}, 1000);

			}, myTimeout);

		}


		// if coming from another page
		if (hash) {
			scroll_to( hash, 2000 );
		}
		// if coming from another page


		// if already on the page
		$("a[href*='#']:not([href='#'])").click(function(e) {
			var hash = this.hash;
			var current_window_location = window.location.href + hash;
			var click_window_location = this.origin + $(e.target.parentElement).attr("href");

			if( current_window_location === click_window_location) {
				// We are already on the same page as the clicked button url.

				e.preventDefault();

				if( hash ) {
					scroll_to( hash, 400 );
				}
			}
		});
		// if already on the page
		//
		// Smooth Scroll


		var width 	= viewportSize.getWidth();
		var height 	= viewportSize.getHeight();
		displayWidth();


		$( window ).resize(function() {
			width = viewportSize.getWidth();
			height = viewportSize.getHeight();
			displayWidth();

			if( width >= 768 ) {
				stick_header();
				if( $('.equal-heights').length > 0 ) {
					$('.equal-heights').matchHeight();
				}
				if( $('#learning-outcomes .equal-heights-two').length > 0 ) {
					$('#learning-outcomes .equal-heights-two > .vc_column-inner').matchHeight({byRow: false});
				}
			} else {
				$("section.header-menu").unstick();
			}

		});


		function displayWidth() {
			$('.dev-page-width').text(width);
			$('.dev-page-height').text(height);
		}



		$('.fancybox').fancybox();





		if( width >= 768 ) {
			stick_header();

			if( $('.equal-heights').length > 0 ) {
				$('.equal-heights').matchHeight();
			}

			if( $('#learning-outcomes .equal-heights-two').length > 0 ) {
				$('#learning-outcomes .equal-heights-two > .vc_column-inner').matchHeight({byRow: false});
			}

		}

		function stick_header() {
			$("section.header-menu").sticky({ topSpacing: 0 });
		}



		// $( '#nav li:has(ul)' ).doubleTapToGo();




		// $('body').addClass('js');

		var $menu = $('#menu'),
			$menulink = $('.menu-link');

		$menulink.click(function() {
			$menulink.toggleClass('active');
			$menu.toggleClass('active');
			return false;
		});



		if( width >= 1024 ) {
			$( 'nav.nav li:has(ul)' ).doubleTapToGo();
		}



		// http://www.smashingmagazine.com/2011/10/18/how-to-use-ajax-in-wordpress/
		// http://premium.wpmudev.org/blog/load-posts-ajax/
		$.ajaxSetup({cache:false});
		$('.ajax_about').click(function(e) {

			e.preventDefault();

			var url = $('.ajax_about').data('url')+
								'/wp-admin/admin-ajax.php?nounce='+
								$('.ajax_about').data('nounce');

					$.ajax({
						url: 	url,
						type: 	'post',
						data: 	{
							action: 'get_variations',
							nonce: $('.ajax_about').data('nounce'),
							page: $('.ajax_about').data('page')
						},
						success: function( html ) {

							// success message here

							$("footer").html(html)

						},
						error: function() {

							// error message here

						}
					})





		});



	});



	$(window).load(function() {


		// Vertically align icons
		adjustHeight();

		$(window).resize(function() {
			adjustHeight();
		});

		function adjustHeight() {

			if( $('.uavc-list-content .uavc-list-icon img.img-icon').length > 0 ) {

				$(".uavc-list-icon-wrapper").each(function( index ) {

					var $icon 	= $('img.img-icon', this).height();
					var $text 	= $('.uavc-list-desc', this).height();

					if( $text > $icon ) {
						$('img.img-icon', this).css('margin-top', ($text - $icon)/2+'px');
					} else {
						$('.uavc-list-desc', this).css('margin-top', ($icon - $text)/2+'px');
					}

				});

			}

		}




// Form Validation - Horizontal / Vertical / Ambassadors / Infosessions

const form = document.getElementById('request-information');
const emailWrapper = document.getElementById('emailWrapper');
const email = document.getElementById('email');
const emailError = document.getElementById('emailerror');
const firstnameWrapper = document.getElementById('firstnameWrapper');
const firstname = document.getElementById('firstname');
const firstnameError = document.getElementById('firstnameerror');
const lastnameWrapper = document.getElementById('lastnameWrapper');
const lastname = document.getElementById('lastname');
const lastnameError = document.getElementById('lastnameerror');
// const phoneWrapper = document.getElementById('phoneWrapper');
// const phone = document.getElementById('phone');
// const phoneError = document.getElementById('phoneerror');
const ambassadorWrapper = document.getElementById('ambassadorWrapper');
const ambassador = document.getElementById('ambassador');
const ambassadorError = document.getElementById('ambassadorerror');
const messageWrapper = document.getElementById('messageWrapper');
const message        = document.getElementById('message');
const messageError   = document.getElementById('messageerror');
const questionWrapper = document.getElementById('questionWrapper');
const question        = document.getElementById('question');
const questionError   = document.getElementById('questionerror');
const infosessionWrapper = document.getElementById('infosessionWrapper');
const infosession = document.getElementById('infosession');
const infosessionError = document.getElementById('infosessionerror');
const eventregistrationWrapper = document.getElementById('eventregistrationWrapper');
const eventregistration = document.getElementById('eventregistration');
const eventregistrationError = document.getElementById('eventregistrationerror');
const programWrapper = document.getElementById('programWrapper');
const programofstudycode = document.getElementById('programofstudycode');
const programError = document.getElementById('programerror');
const submitButton = document.getElementById('submit');

// Show Pardot error messaging
if (window.location.href.indexOf('errors=true') > 0) {
	// jQuery("#error").show();

	var urlParams = new URLSearchParams(window.location.search);

	if (window.location.href.indexOf('email-required') > 0) {
		emailWrapper.className = 'fieldwrap input error active pardot';
		ValidateEmail();
	}
	if (window.location.href.indexOf('firstname-required') > 0) {
		firstnameWrapper.className = 'fieldwrap input error active pardot';
		ValidateFirstName();
	}
	if (window.location.href.indexOf('lastname-required') > 0) {
		lastnameWrapper.className = 'fieldwrap input error active pardot';
		ValidateLastName();
	}
	// if (window.location.href.indexOf('phone-required') > 0) {
	// 	phoneWrapper.className = 'fieldwrap input error active pardot';
	// 	ValidatePhone();
	// }

	if (window.location.href.indexOf('message-required') > 0) {
		messageWrapper.className = 'fieldwrap input error active pardot';
		ValidateMessage();
	}

	if (window.location.href.indexOf('question-required') > 0) {
		questionWrapper.className = 'fieldwrap input error active pardot';
		ValidateQuestion();
	}

	if (window.location.href.indexOf('select-programofstudycode') > 0) {
		programWrapper.className = 'fieldwrap input error active pardot';
		ValidateProgram();
	}
	if (
		(window.location.href.indexOf('infosessionurl-required') > 0) ||
		(window.location.href.indexOf('infosessiondate-required') > 0) ||
		(window.location.href.indexOf('infosessiontime-required') > 0)
	) {
		infosessionWrapper.className = 'fieldwrap input error active pardot';
		ValidateInfoSession();
	}

	if (
		(window.location.href.indexOf('eventdisplaytime-required') > 0) ||
		(window.location.href.indexOf('eventdisplaydate-required') > 0) ||
		(window.location.href.indexOf('eventtimeutciso8601-required') > 0) ||
		(window.location.href.indexOf('eventurl-required') > 0)
	) {
		eventregistrationWrapper.className = 'fieldwrap input error active pardot';
		ValidateEventRegistration();
	}

	if (urlParams.has('email')) {
		email.value = urlParams.get('email');
	}

	if (urlParams.has('firstname')) {
		firstname.value = urlParams.get('firstname');
	}

	if (urlParams.has('lastname')) {
		lastname.value = urlParams.get('lastname');
	}

	// if (urlParams.has('phone')) {
	// 	phone.value = urlParams.get('phone');
	// }

	if (urlParams.has('programofstudycode')) {
		programofstudycode.value = urlParams.get('programofstudycode');
	}
}

if (window.location.href.indexOf('errors=false') > 0) {
	jQuery("#success").show();
}

// Form - request-information (horizontal / vertical)

if (form) {
	form.addEventListener('submit', function (event) {

		//Capture Google Analytics variables
		//this does not work with gtag.js (GA4)

		ga(function () {
			var tracker = ga.getAll()[0];
			var clientId = tracker.get('clientId');
			document.getElementById('GACLIENTID').value = clientId;
			var trackingId = tracker.get('trackingId');
			document.getElementById('GATRACKID').value = trackingId;
		});

		submitButton.innerHTML = '<div class="spinner">' +
			'<svg class="spinner" viewBox="0 0 50 50">' +
			'<circle circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>' +
			'</svg>' +
			'</div>';

		// jQuery("#error").hide();

		if (
			!email.validity.valid ||
			!firstname.validity.valid ||
			!lastname.validity.valid ||
			//!message.validity.valid ||
			// !phone.validity.valid ||
			(ambassador && !ambassador.validity.valid) ||
			(infosession && !infosession.validity.valid) ||
			(eventregistration && !eventregistration.validity.valid) ||
			(programofstudycode && !programofstudycode.validity.valid)
		) {
			// If it isn't, we display an appropriate error message
			showError();

			// Then we prevent the form from being sent by canceling the event
			submitButton.innerHTML = 'Submit';

			event.preventDefault();
			// **** comment this line for Pardot server validation

		} else {
			// Set form fields

			// If after jQuery errors are resolved, remove the error styling.
			jQuery('.fieldwrap.input.error.active').removeClass('input').removeClass('error').removeClass('active');

			if (jQuery("#infosession").length > 0) {
				var infosessionParts = jQuery("#infosession").val().split("|");
				jQuery("#infosessionurl").val(infosessionParts[2]);
				jQuery("#infosessiondate").val(infosessionParts[0]);
				jQuery("#infosessiontime").val(infosessionParts[1]);
			}

			if (jQuery("#eventregistration").length > 0) {
				var eventParts = jQuery("#eventregistration").val().split("|");
				jQuery("#eventdisplaydate").val(eventParts[0]);
				jQuery("#eventdisplaytime").val(eventParts[1]);
				jQuery("#eventurl").val(eventParts[2]);
				jQuery("#eventtimeutciso8601").val(eventParts[3]);
				jQuery("#eventdurationminutes").val(eventParts[4]);
			}


			// REMOVE THIS WHEN DONE TESTING
			// event.preventDefault();
			// jQuery("#success").show();
		}
	});

}
// Form - request-information (horizontal / vertical)

function showError() {
	ValidateFirstName();
	ValidateLastName();
	ValidateEmail();
	// ValidatePhone();;
	// ValidateMessage();
	if (ambassador) {
		ValidateAmbassador();
	}
	if (infosession) {
		ValidateInfoSession();
	}
	if (eventregistration) {
		ValidateEventRegistration();
	}
	if (programofstudycode) {
		ValidateProgram();
	}
}
function ValidateFirstName() {
	if (firstname.validity.valueMissing) {
		firstnameError.textContent = 'Please enter your first name.';
		firstnameError.className = 'input error active';
		firstnameWrapper.className = 'fieldwrap input error active';
	} else {
		//reset
		firstnameError.innerHTML = ''; // Reset the content of the message
		firstnameError.className = 'error'; // Reset the visual state of the message
		firstnameWrapper.className = 'fieldwrap';
	}
}
function ValidateLastName() {
	if (lastname.validity.valueMissing) {
		lastnameError.textContent = 'Please enter your last name.';
		lastnameError.className = 'input error active';
		lastnameWrapper.className = 'fieldwrap input error active';
	} else {
		//reset
		lastnameError.innerHTML = ''; // Reset the content of the message
		lastnameError.className = 'error'; // Reset the visual state of the message
		lastnameWrapper.className = 'fieldwrap';
	}
}
function ValidateMessage() {
	if (message.validity.valueMissing) {
		messageError.textContent = 'Please enter your message here.';
		messageError.className = 'input error active';
		messageWrapper.className = 'fieldwrap input error active';
	} else {
		//reset
		messageError.innerHTML = ''; // Reset the content of the message
		messageError.className = 'error'; // Reset the visual state of the message
		messageWrapper.className = 'fieldwrap';
	}
}

function ValidateQuestion() {
	if (question.validity.valueMissing) {
		questionError.textContent = 'Please enter your question here.';
		questionError.className = 'input error active';
		questionWrapper.className = 'fieldwrap input error active';
	} else {
		//reset
		questionError.innerHTML = ''; // Reset the content of the message
		questionError.className = 'error'; // Reset the visual state of the message
		questionWrapper.className = 'fieldwrap';
	}
}

function ValidateAmbassador() {
	if (ambassador.validity.valueMissing) {
		ambassadorError.textContent = 'Please choose an ambassador.';
		ambassadorError.className = 'input error active';
		ambassadorWrapper.className = 'fieldwrap input error active';
	} else {
		//reset
		ambassadorError.innerHTML = ''; // Reset the content of the message
		ambassadorError.className = 'error'; // Reset the visual state of the message
		ambassadorWrapper.className = 'fieldwrap';
	}
}
function ValidateInfoSession() {
	if (infosession.validity.valueMissing) {
		infosessionError.textContent = 'Please choose an information session.';
		infosessionError.className = 'input error active';
		infosessionWrapper.className = 'fieldwrap input error active';
	} else {
		//reset
		infosessionError.innerHTML = ''; // Reset the content of the message
		infosessionError.className = 'error'; // Reset the visual state of the message
		infosessionWrapper.className = 'fieldwrap';
	}
}

function ValidateEventRegistration() {
	if (eventregistration.validity.valueMissing) {
		eventregistrationError.textContent = 'Please choose an event.';
		eventregistrationError.className = 'input error active';
		eventregistrationWrapper.className = 'fieldwrap input error active';
	} else {
		//reset
		eventregistrationError.innerHTML = ''; // Reset the content of the message
		eventregistrationError.className = 'error'; // Reset the visual state of the message
		eventregistrationWrapper.className = 'fieldwrap';
	}
}

function ValidateProgram() {
	if ( !jQuery(programofstudycode).is(":hidden") ) {
		if (programofstudycode.validity.valueMissing) {
			programError.textContent = 'Please choose a program.';
			programError.className = 'input error active';
			programWrapper.className = 'fieldwrap input error active';
		} else {
			//reset
			programError.innerHTML = ''; // Reset the content of the message
			programError.className = 'error'; // Reset the visual state of the message
			programWrapper.className = 'fieldwrap';
		}
	}
}
// function ValidatePhone() {
//     if (phone.validity.valueMissing) {
//         phoneError.textContent = 'Please enter a phone number.';
// 		phoneError.className = 'input error active';
// 		phoneWrapper.className = 'fieldwrap input error active';
//     } else if (phone.validity.patternMismatch) {
//         phoneError.textContent = 'Please enter a phone number in the format of ###-###-####)';
// 		phoneError.className = 'input error active';
// 		phoneWrapper.className = 'fieldwrap input error active';
//     } else {
//         //reset
//         phoneError.innerHTML = ''; // Reset the content of the message
// 		phoneError.className = 'error'; // Reset the visual state of the message
// 		phoneWrapper.className = 'fieldwrap';
//     }
// }
function ValidateEmail() {
	if ( email.validity.valueMissing ) {
		emailError.textContent = 'Please enter an e-mail address.';
		emailError.className = 'input error active';
		emailWrapper.className = 'fieldwrap input error active';
	} else if (email.validity.typeMismatch) {
		emailError.textContent = 'Entered value needs to be an e-mail address.';
		emailError.className = 'input error active';
		emailWrapper.className = 'fieldwrap input error active';
	} else if (email.validity.tooShort) {
		emailError.textContent = 'Email should be at least ${ email.minLength } characters; you entered ${ email.value.length }.';
		emailError.className = 'input error active';
		emailWrapper.className = 'fieldwrap input error active';
	} else {
		//reset
		emailError.innerHTML = ''; // Reset the content of the message
		emailError.className = 'error'; // Reset the visual state of the message
		emailWrapper.className = 'fieldwrap';
	}
}

var cookies = {
	read: function (name) {

		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ')
				c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0)
				return c.substring(nameEQ.length, c.length);
		}
	}
}
function SetFirstUtm(utm_param) {
	if (cookies.read('__ft_utm_' + utm_param) != undefined) {
		jQuery('input[name="first_utm_' + utm_param + '"]').val(''); //reset
		jQuery('input[name="first_utm_' + utm_param + '"]').val(cookies.read('__ft_utm_' + utm_param));
	}
}
function SetGCLID(utm_param) {
	if (cookies.read('__lt_gclid') != undefined) {
		jQuery('input[name="GCLID"]').val(''); //reset
		jQuery('input[name="GCLID"]').val(cookies.read('__lt_gclid'));
	}
}
SetFirstUtm('source');
SetFirstUtm('medium');
SetFirstUtm('campaign');
SetFirstUtm('content');
SetFirstUtm('term');
SetGCLID();

// Form Validation - Horizontal / Vertical / Ambassadors / Infosessions

	});

})(jQuery, this);
